<template>
<div class="JobInfo">
    <div class="job_top_box">
        <div class="Telchar_box">
            <div class="left">
                <!-- <a href="#job_description" title="Web前端开发工程师">Web前端开发工程师</a> -->
                <p class="job_title">
                    <!-- <a :title="JobDetailInfo.jobname">{{JobDetailInfo.jobname}}</a> -->
                    <span class="telchar-nx" :title="`${JobDetailInfo.salarymin}-${JobDetailInfo.salarymax}万`">{{JobDetailInfo.salarymin}}-{{JobDetailInfo.salarymax}}万</span>
                    <span class="telchar-nx">{{JobDetailInfo.salarytext}}</span>
                </p>
                <p class="company_title">
                    <a>{{JobDetailInfo.companyname}}</a>
                </p>
                <p class="company_title">
                    <a>{{JobDetailInfo.companydisplayname}}</a>
                </p>
                <p class="ssbm_text" v-if="JobDetailInfo.deptname !== '' && JobDetailInfo.hbname !== ''">所属部门：{{JobDetailInfo.deptname}} <span></span> 汇报对象：{{JobDetailInfo.hbname}}</p>
                <p class="ssbm_text" v-if="JobDetailInfo.deptname === '' && JobDetailInfo.hbname !== ''">汇报对象：{{JobDetailInfo.hbname}}</p>
                <p class="ssbm_text" v-if="JobDetailInfo.deptname !== '' && JobDetailInfo.hbname === ''">所属部门：{{JobDetailInfo.deptname}}</p>
                <div class="tag_box">
                    <span>{{JobDetailInfo.edutypename}}</span>
                    <span v-if="JobDetailInfo.agemin === 0 && JobDetailInfo.agemax === 0">年龄不限</span>
                    <span v-else>{{JobDetailInfo.agemin}}岁-{{JobDetailInfo.agemax}}岁</span>
                    <span>{{JobDetailInfo.exptypename}}</span>
                    <span><label v-if="JobDetailInfo.sextype === 0">性别</label>{{JobDetailInfo.sextypename}}</span>
                </div>
                <!-- <p class="jobtime">本信息由{{JobDetailInfo.companyname}}发布于{{JobDetailInfo.jobtime}}，联系电话：{{releaseName}}&nbsp;{{JobDetailInfo.jobtel}}</p> -->
            </div>
            <div class="right">
                <div v-if="JobDetailInfo.status === 1" @click="sendResumeBtn" class="btn_div" :class="JobDetailInfo.issendresum === 1 ? '' : 'btn_div2'">
                    <img :src="require('@/common/images/talentsimg/icon.png')" alt="">
                    <span v-if="JobDetailInfo.issendresum === 1">投递简历</span>
                    <span v-else>已投递</span>
                </div>
                <div v-else class="btn_div gray_bc">停止招聘</div>
                <div class="links_box">
                    <div @click="toResume" class="wszxjl">
                        <i></i>
                        <span class="vam">完善在线简历</span>
                    </div>
                    <div @click="toResume" class="scfjjl">
                        <i></i>
                        <span class="vam">上传附件简历</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="job_content_box">
        <div class="content_left_box">
            <div class="title_text"><strong><a>岗位职责</a></strong></div>
            <div class="content_div" v-html="JobDetailInfo.dutyinfo"></div>
            <div class="title_text top40"><strong><a>岗位要求</a></strong></div>
            <div class="content_div" v-html="JobDetailInfo.resinfo"></div>
            <div v-if="JobDetailInfo.welfareinfo" class="title_text top40"><strong><a>福利待遇</a></strong></div>
            <div v-if="JobDetailInfo.welfareinfo" class="content_div" v-html="JobDetailInfo.welfareinfo"></div>
            <div class="title_text top40"><strong><a href="#job_description" id="job_company">企业介绍</a></strong></div>
            <div class="content_div" v-html="JobDetailInfo.desp"></div>
            <div class="title_text top40"><strong><a>企业性质</a></strong></div>
            <div class="content_div">
                <img :src="require('@/common/images/talentsimg/icon5.png')" alt="">
                <p>{{JobDetailInfo.companytypename}}</p>
            </div>
            <div class="title_text top40"><strong><a>工作地点</a></strong></div>
            <div class="content_div">
                <img :src="require('@/common/images/talentsimg/icon6.png')" alt="">
                <p>{{JobDetailInfo.jobplace}}</p>
            </div>
        </div>
        <div class="content_right_box">
            <login-card></login-card>
            <slide-list :List="recommendJobList" label="相关职位信息"></slide-list>
        </div>
    </div>
    <talent-button-silder></talent-button-silder>
    <div class="tips_pop_div">
        <el-dialog title="提示" :visible.sync="dialogVisible">
            <div class="tips_text_div">{{tipsText}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="toResume">完善简历</el-button>
            </span>
        </el-dialog>
    </div>
    <div class="tips_pop_div">
        <el-dialog title="提示" :visible.sync="dialogVisible2">
            <div class="tips_text_div">您已投递过该岗位</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible2 = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
    <div class="tips_pop_div">
        <el-dialog title="提示" :visible.sync="dialogVisible3">
            <div class="tips_text_div">您的简历投递成功，快去看看其他职位吧！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible3 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible3 = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {getJobDetail} from 'api/talentApi'
import {getRecommendJob, sendResumeInfo} from 'api/talent'
import {mapGetters, mapActions} from 'vuex'
import LoginCard from '../components/LoginCard'
import SlideList from '../components/SlideList'
import TalentButtonSilder from './../components/TalentButtonSilder'
export default {
    name: 'JobInfo',
    data() {
        return {
            JobDetailInfo: {},
            dialogVisible: false,
            tipsText: '',
            dialogVisible2: false,
            dialogVisible3: false,
            recommendJobList: [], // 推荐岗位数据
            isZJ178Domain:false,//是否是资鲸178域名，需要屏蔽直播和资讯
            releaseName:""
        }
    },
    created() {
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MJobInfo',
                query: {'jobid': this.$route.query.jobid}
            })
        }
    },
    mounted() {
        this.findJobDetail(true)
        if(location.hostname.indexOf("zj178.com")>=0){
            this.isZJ178Domain=true
        }
        // let releaseNameArray=["江先生","黄女士","包女士","高先生","徐先生","李小姐","莫小姐","曾女士"]
        // let pos=parseInt(Math.random()*releaseNameArray.length) 
        // this.releaseName=releaseNameArray[pos]
    },
    methods: {
        // 投递简历按钮
        sendResumeBtn() {
            if (this.user.isLogin) {
                if (this.JobDetailInfo.issendresum === 1) {
                    if (this.JobDetailInfo.fullrate === 0) {
                        this.tipsText = '您当前暂未完善在线简历，请先完善在线简历后在进行岗位投递'
                        this.dialogVisible = true
                    } else if (this.JobDetailInfo.fullrate < 100) {
                        this.tipsText = '请先将简历基本信息、工作经历、项目经历、教育经历填写完整在进行岗位投递'
                        this.dialogVisible = true
                    } else {
                        this.setLoading(true)
                        var params = {
                            jobinnerid: this.$route.query.jobid
                        }
                        sendResumeInfo({
                            data: Object.assign({}, params),
                            success: () => {
                                this.setLoading(false)
                                // console.log(data.data)
                                this.JobDetailInfo.issendresum = 0
                                this.dialogVisible3 = true
                            },
                            error: data => {
                                this.setLoading(false)
                                this.$message.error(data.msg)
                            }
                        })
                    }
                } else {
                    this.dialogVisible2 = true
                }
            } else {
                this.setLoginPop(true)
            }
        },
        // 跳转到我的简历
        toResume() {
            this.$router.push({name: 'Resume'})
        },
        // 获取岗位详情信息
        findJobDetail(val) {
            this.setLoading(true)
            var params = {
                jobinnerid: this.$route.query.jobid
            }
            getJobDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.JobDetailInfo = data.data
                    if (val) {
                        this.findRecommendJob()
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取推荐岗位
        findRecommendJob() {
            this.setLoading(true)
            var params = {
                searchtype: 2,
                jobtypecode01: this.JobDetailInfo.jobtypecode01,
                jobtypecode02: this.JobDetailInfo.jobtypecode02
            }
            getRecommendJob({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.recommendJobList = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    filters: {},
    watch: {
        user: function(newVal, oldVal) {
            if (newVal != oldVal) {
                // location.reload()
                this.findJobDetail(true)
            }
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {
        LoginCard,
        SlideList,
        TalentButtonSilder
    }
}
</script>

<style lang="scss" type="text/scss">
.JobInfo {
    // background-color: #F9F9F9;
    // min-height: 600px;
    a{
        cursor: pointer;
    }
    .job_top_box {
        margin: 0 auto 20px;
        height: 240px;
        min-width: 1200px;
        background: transparent url(../../../common/images/talentsimg/job_bg.png) center center no-repeat;
        background-size: cover;
        .Telchar_box {
            padding: 0 10px;
            // padding-top: 40px;
            box-sizing: border-box;
            width: 1200px;
            height: 240px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: white;
            .left {
                .job_title {
                    font-size: 28px;
                    font-weight: normal;
                    line-height: 1;
                    padding: 0;
                    a {
                        display: inline-block;
                        max-width: 660px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 32px;
                        font-weight: bold;
                    }
                    span {
                        color: #FF9317;
                        font-size: 32px;
                        display: inline-block;
                        padding: 0 0 0 18px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .company_title {
                    margin-top: 10px;
                    margin-bottom: 15px;
                    line-height: 28px;
                    a {
                        font-size: 20px;
                    }
                }
                .ssbm_text {
                    font-size: 14px;
                    line-height: 20px;
                    margin-bottom: 15px;
                    span {
                        display: inline-block;
                        width: 0;
                        height: 10px;
                        border-left: 1px solid #fff;
                        margin: 0 8px;
                        vertical-align: middle;
                    }
                }
                .tag_box {
                    span {
                        margin-right: 10px;
                        border: 1px solid #5EBDFF;
                        color: #5EBDFF;
                        padding: 3px 16px;
                        border-radius: 13px;
                        font-size: 13px;
                        line-height: 25px;
                    }
                }
                .jobtime {
                    color: #fff;
                    font-size: 12px;
                    margin-top: 20px;
                }
                a{
                    color: white;
                    cursor: pointer;
                }
                a:hover{
                    color:#5EBDFF;
                }
            }
            .right {
                // margin-top: 46px;
                .btn_div {
                    cursor: pointer;
                    margin-bottom: 15px;
                    width: 300px;
                    height: 50px;
                    background: #3B87FF;
                    border-radius: 3px;
                    color: white;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                    }
                    span {
                        font-size: 14px;
                    }
                }
                .btn_div2 {
                    background:#96BFFF;
                }
                .gray_bc {
                    background-color: #999;
                }
                .links_box {
                    display: flex;
                    justify-content: space-between;
                    &>div {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        i {
                            display: inline-block;
                            width: 20px;
                            height: 20px;
                            background-image: url(../../../common/images/talentsimg/icon1.png);
                            background-size: 100% 100%;
                            margin-right: 4px;
                        }
                        span {
                            font-size:13px;
                        }
                    }
                    .wszxjl:hover {
                        i {
                            background-image: url(../../../common/images/talentsimg/icon2.png);
                        }
                        span {
                            color: #5EBDFF;
                        }
                    }
                    .scfjjl {
                        i {
                            background-image: url(../../../common/images/talentsimg/icon3.png);
                        }
                    }
                    .scfjjl:hover {
                        i {
                            background-image: url(../../../common/images/talentsimg/icon4.png);
                        }
                        span {
                            color: #5EBDFF;
                        }
                    }
                }
            }
        }
    }
    .job_content_box {
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 60px;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .content_left_box {
            background-color: #fff;
            width: 865px;
            padding: 30px 20px;
            box-sizing: border-box;
            .top40 {
                margin-top: 40px;
            }
            .title_text {
                display: block;
                text-align: left;
                overflow: hidden;
                color: #17365D;
                height: 26px;
                line-height: 26px;
                font-size: 20px;
                padding-bottom: 10px;
                position: relative;
                margin-bottom: 18px;
                a {
                    color: #333;
                    font-weight: bold;
                }
            }
            .title_text::after {
                content: "";
                position: absolute;
                bottom: 2px;
                left: 0;
                width: 44px;
                height: 2px;
                background: transparent url(../../../common/images/talentsimg/icon_line.png) left top no-repeat;
                background-size: 100%;
            }
            .content_div {
                font-size: 14px;
                color: #666;
                line-height:20px;
                display: flex;
                &>img {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }
            }
        }
        .content_right_box {
            width: 300px;
            min-height: 400px;
            .LoginCard {
                margin-top: 0;
                margin-bottom: 20px;
            }
            .SlideList {
                margin-top: 0;
            }
        }
    }
    .tips_pop_div {
        .el-dialog .el-dialog__header {
            border-bottom: 1px solid #DCDFE6;
        }
        .el-dialog__headerbtn {
            top: 14px;
        }
        .el-dialog__header {
            padding: 10px 20px 10px;
        }
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
        }
        .el-dialog {
            margin: 0!important;
            width: 600px;
        }
        .el-dialog__title {
            font-size: 14px;
        }
        .el-dialog .el-dialog__body {
            padding: 50px 20px;
        }
        .el-dialog__footer {
            text-align: center;
            padding: 0;
            padding-bottom: 40px;
            .el-button {
                width: 95px;
                padding: 8px 20px;
            }
        }
        .tips_text_div {
            text-align: center;
            color: #606266;
            font-size: 16px;
        }
    }
}
</style>